import React, {useEffect, useRef} from 'react';
import './CodePickerDigit.less';
import {PageFocusPriorityTargetClass} from "new-constants/common.constants";

function moveCursorToInputEnd(inputRef) {
	inputRef.current.selectionStart = inputRef.current.value.length;
	inputRef.current.selectionEnd = inputRef.current.value.length;
}

export const CodePickerDigit = ({value, isHidden, index, isFocused, onFocus, onChange, ariaDigitLabel = ''}) => {
	const inputRef = useRef(null);

	useEffect(() => {
		if (isFocused) {
			inputRef.current.focus({preventScroll: true});
		}
	}, [isFocused]);

	return (
		<input
			ref={inputRef}
			type="tel"
			value={isHidden && value.length > 0 ? '●' : value}
			className={
				'code-picker-digit' +
				(value && isHidden ? ' code-picker-digit--hidden' : '') +
				' ' +
				PageFocusPriorityTargetClass
			}
			autoCorrect="off"
			autoComplete="off"
			autoCapitalize="off"
			spellCheck="false"
			maxLength="2"
			onClick={() => {
				setTimeout(() => moveCursorToInputEnd(inputRef), 0);
			}}
			onFocus={() => {
				onFocus && onFocus(index);
			}}
			onKeyDown={e => {
				if (!e) return;

				if (e.keyCode === 8) {
					onChange('', index);
				}
			}}
			onInput={e => {
				//onKeyDown doesn't return key code on Samsung
				if (!e) return;

				if (/^\d{1,2}$/.test(e.target.value)) {
					onChange(e.target.value[e.target.value.length - 1], index);
				}
			}}
			aria-label={ariaDigitLabel.replace('{index}', index + 1)}
		/>
	);
}
